import React from 'react';
import EmptyState from '../components/EmptyState';

const DevTemplatesPage = () => {
  return (
    <div className="flex flex-col gap-6 p-6">
      <header>
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50">Templates</h1>
        <p className="text-sm text-slate-500">Templates and analytics</p>
      </header>
      <EmptyState message="Templates page - Coming soon" />
    </div>
  );
};

export default DevTemplatesPage;
